import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  FetchInitialInvoiceValuesActionType,
  FETCH_INITIAL_INVOICE_VALUES_SUCCESS,
  FETCH_INITIAL_INVOICE_VALUES_FAILURE,
  FETCH_INITIAL_INVOICE_VALUES
} from 'src/redux/invoiceReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchInvoiceInitialValuesFlow(action: FetchInitialInvoiceValuesActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = `/dealers_api/invoices/${action.payload.id}/initial_form_values`
    const response = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: GET,
      params: {}
    })
    yield put(FETCH_INITIAL_INVOICE_VALUES_SUCCESS(response))
  } catch (error) {
    yield put(FETCH_INITIAL_INVOICE_VALUES_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchInvoiceInitialValues(): Generator<any, void, any> {
  yield takeLatest(FETCH_INITIAL_INVOICE_VALUES, FetchInvoiceInitialValuesFlow)
}
